import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProofSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-24 px-6 relative overflow-hidden" style={{
    background: '#162030'
  }} data-id="element-223">
      {/* Warm ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(212,168,83,0.08) 0%, transparent 70%)'
    }} data-id="element-224" />

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-225">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-226">
          <div className="amber-divider mb-8" data-id="element-227" />
          <p className="text-center text-sm uppercase tracking-widest mb-4" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#D4A853'
        }} data-id="element-228">
            Visualisez
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-229">
            Imaginez votre prochaine nuit...
          </h2>

          <div className="rounded-2xl p-8 md:p-10" style={{
          background: 'rgba(212,168,83,0.04)',
          border: '1px solid rgba(212,168,83,0.15)'
        }} data-id="element-230">
            <p className="text-lg md:text-xl leading-relaxed mb-6" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8',
            fontStyle: 'italic'
          }} data-id="element-231">
              "Éteindre la lumière à 22h30, appliquer le protocole, et sentir
              vos muscles se relâcher totalement."
            </p>
            <p className="text-base leading-relaxed mb-6" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-232">
              Pas de lutte. Pas de larmes. Juste un glissement naturel vers le
              sommeil.
            </p>
            <p className="text-base leading-relaxed" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-233">
              Le lendemain matin, vous vous réveillez sans cette{' '}
              <strong style={{
              color: '#F5F0E8'
            }} data-id="element-234">
                "gueule de bois émotionnelle"
              </strong>
              , prête à gérer votre vie avec clarté et énergie.
            </p>
          </div>

          {/* Stars / social proof visual */}
          <div className="flex justify-center mt-8 gap-1" data-id="element-235">
            {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-xl" style={{
            color: '#D4A853'
          }} data-id="element-236">
                ★
              </span>)}
          </div>
          <p className="text-center text-sm mt-2" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#8A8070'
        }} data-id="element-237">
            Des centaines de femmes ont déjà retrouvé le sommeil
          </p>
        </div>
      </div>
    </section>;
}